<template>
  <div class="row">
    <!-- /.col -->
    <div class=" col-lg-12">
      <div class="card">
        <div class="card-header p-2">
          <ul class="nav nav-pills">
            <li class="nav-item" style="margin-right: 10px;"><a class="nav-link active" href="#activity" data-toggle="tab" v-on:click="currentTab = 'profile'">Client Info</a></li>
            <!--<li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'benificial'">Benificial Ownership</a></li>-->
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'customerrisk'">Customer Risk Profiling</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'highlowrisk'">High Low Risk Customer</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'document'">Document Required</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'brassignment'">Branch Assignment</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'attachments'">Attachments</a></li>
          </ul>
        </div><!-- /.card-header -->

        <component :is="currentTab" :clientid="id"></component>

      </div>
      <!-- /.card -->
    </div>
    <!-- /.col -->
  </div>
</template>

<script>

  const axios = require('axios').default;

  import clientProfile from './AdvanceClientProfile.vue';
  //import benificialownership from './BenificialOwnership.vue';
  import costumerriskprofiling from './CustomerRiskProfiling.vue';
  import highlowriskcustomer from './HighLowRiskCustomer.vue';
  import documentrequired from './DocumentRequired.vue';
  import branchassignment from './BranchAssignment.vue';
  import attachment from './Attachments.vue';




  export default ({
    data() {
      return {
        id: 0,
        activeTab: 1,
        currentTab: 'profile',
        //emp: { Name: 'Hamza', EmpCode: 100, Contact: '', Email: ''}
        shortDetail: null,
        img: '/dist/icon-profile.png',
        basicHR: false,
        //../../../../wwwroot/Images/icon-profile.png
      }
    },
    components: {
      'profile': clientProfile,
      //'benificial': benificialownership,
      'customerrisk': costumerriskprofiling,
      'highlowrisk': highlowriskcustomer,
      'document': documentrequired,
      'brassignment': branchassignment,
      'attachments': attachment
    },
    created: function () {
      startReq();
      var vm = this;
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams) {
        this.id = Number(urlParams.get('id'));
        //var uri = window.location.toString();
        //if (uri.indexOf("?") > 0) {
        //  var clean_uri = uri.substring(0, uri.indexOf("?"));
        //  window.history.replaceState({}, document.title, clean_uri);
        //}
      }
    },
  })</script>

<style scoped>
  .nav-tabs.flex-column .nav-item.show .nav-link, .nav-tabs.flex-column .nav-link.active {
    border-left: 3px solid #17a2b8;
  }

  .nav-item active {
    background-color: #17a2b8
  }

  .list-group-item {
    padding: 2px 0px;
  }

  .profile-username {
    font-size: 20px;
    margin-top: 5px;
  }

  .nav-link {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/IndividualProfile.vue